import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import TrackerAddEditMeal from '../components/TrackerAddEditMeal';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeFavMeal } from '../helpers/normalizers';
import { FavMealProps } from '../types';

const TrackerAddFavMealContainer: React.FC<FavMealProps & { dietMealId?: string }> = (props) => {
  const normalizedProps = normalizeFavMeal(props);
  sessionStorage.setItem('tracker_depth', '1');
  return (
    <TrackerAddEditMeal
      key={normalizedProps.mealData.id}
      {...normalizedProps}
      dietMealId={props.dietMealId}
    />
  );
};

export default withLoading(TrackerAddFavMealContainer, UniversalPlaceholder);
